module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        _vm.deleteRow(_vm.index)
      }
    }
  }, [_vm._v("close")])]), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "Bulk add"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.bulk),
      callback: function($$v) {
        _vm.bulk = $$v
      },
      expression: "bulk"
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addModels
    }
  }, [_vm._v("Toevoegen")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-119668d2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popups/Bulk-popup.vue
// module id = 220
// module chunks = 1